import { Component, ViewContainerRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { SessionSetting, Resources } from './app.service';
import { UserMangerEditComponent } from "app/pf.main/usermanger/usermangeredit/usermangeredit.component";
import { Pslistener } from "app/pf.core/listener/Pslistener";

declare var config: any;

@Component({
  selector: 'app-root',
  template: `<router-outlet></router-outlet>
  <app-user-manger-edit formId="appUserForm" #user></app-user-manger-edit>
  `
})
export class AppComponent implements OnInit {
  public title = 'Welcome';

  @ViewChild('user') modal: UserMangerEditComponent;

  public constructor(
    private viewContainerRef: ViewContainerRef,
    private router: Router,
    private location: Location
  ) {}

  ngOnInit() {
    Resources.init();

    let path = this.location.path();
    if (path.indexOf('/buy/') > -1) {
      SessionSetting.set('buyProduct', path.replace('/buy/', ''));
    }

    if (!SessionSetting.getUser()) {
      if (path.indexOf('/market/') > -1) {
        
      }
      else {
        if (config.devMode) {
          this.router.navigate(['login']);
        } else {
          this.router.navigate(['home']);
        }
      }
    }

    Pslistener.appUserEdit.dialog = this.modal;
  }
}



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/app.component.ts